import {config} from "./walletConnectConfig";
import {WagmiProvider} from "wagmi";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {ConnectKitProvider} from "connectkit";
import {BrowserRouter, Routes} from "react-router";

const queryClient = new QueryClient()

export function AppProviders({children}) {
  return (
        <WagmiProvider config={config}>
          <QueryClientProvider client={queryClient}>
            <ConnectKitProvider>
              <BrowserRouter>
                <Routes>
                {children}
                </Routes>
              </BrowserRouter>
            </ConnectKitProvider>
          </QueryClientProvider>
        </WagmiProvider>
  )
}
